import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mapKeys, omit } from 'lodash-es';
import type { Deliveryman } from '../../types';

type DeliverymanState = Record<number, Deliveryman>;

const initialState: DeliverymanState = {};

const deliverymanSlice = createSlice({
  name: 'deliveryman',
  initialState,
  reducers: {
    setDeliverymen(state, action: PayloadAction<Deliveryman[]>) {
      return mapKeys(action.payload, 'id') as unknown as DeliverymanState;
    },
    pushDeliveryman(state, action: PayloadAction<Deliveryman>) {
      state[action.payload.id] = action.payload;
    },
    deleteDeliveryman(state, action: PayloadAction<{ id: number }>) {
      return omit(state, action.payload.id) as DeliverymanState;
    },
  },
});

export const { setDeliverymen, pushDeliveryman, deleteDeliveryman } = deliverymanSlice.actions;
export default deliverymanSlice.reducer;
